'use strict';

import axios from '../../utils/axios';

//精选文章

export const queryArticle = async (params) => {
    const { current, size, tab, subcat } = params;
    const res = await axios.get(
        `/api/opencms/index?current=${current}&size=${size}&tab=${tab}&subcat=${subcat}&category=文章`
    );
    return res;
};

export const queryTopArticle = async (params) => {
    const { category } = params;
    const res = await axios.get(`/api/opencms/index/top?current=1&size=1&tab=all&category=${category}`);
    return res;
};

export const queryIssue = async (params) => {
    const { current, size, tab, subcat } = params;
    const res = await axios.get(
        `/api/opencms/index?current=${current}&size=${size}&subcat=${subcat}&tab=${tab}&category=问答`
    );
    return res;
};
export const queryTags = async () => {
    const res = await axios.get(`/api/opencms/tags?current=1&size=10`);
    return res.records;
};

export const queryIssueDetail = async (id) => {
    const res = await axios.get(`/api/opencms/topic/${id}`);

    let arr = [];
    res.comments.forEach((item) => {
        if (item.layer === 0) arr.push(item);
    });
    function recursion(id, child) {
        let arr = res.comments.filter((e) => {
            return id === e.commentId;
        });
        if (arr.length > 0) {
            child.push(...arr);
            return arr.forEach((item) => {
                recursion(item.id, child);
            });
        } else {
            return;
        }
    }
    arr.forEach((item) => {
        recursion(item.id, (item.child = []));
        let childArr = [];
        item.child.forEach((childItem) => {
            if (childItem.layer === 1) childArr.push(childItem);
        });
        childArr.forEach((e) => {
            recursion(e.id, (e.child = []));
        });
        item.child = childArr;
    });
    res.comments = arr;
    let stringArr = '';
    if (res.content.includes('<quill-editor-html-text>')) {
        stringArr = res.content.split('<quill-editor-html-text>');
        res.isMarkdown = false;
    } else {
        stringArr = res.content.split('<md-editor-html-text>');
        res.isMarkdown = true;
    }
    res.content = stringArr.length > 0 ? stringArr[0] : res.content;
    return res;
};
//评论
export const create = async (params) => {
    const res = await axios.post(`/api/opencms/comment/create`, params);
    return res;
};

export const vote = async (id) => {
    const res = await axios.get(`/api/opencms/comment/vote/${id}`);
    return res;
};
